var initValidator = function (container) {
    //Validate
    $(container).each(function() {
        $(this).validate({
            errorClass: 'is-invalid',
            validClass: "is-valid",
            errorElement: "div",
            dynamic: {
                settings: {
                    trigger: "keyup"
                }
            }
        });
    });

    //Regex Method
    $.validator.addMethod(
        "regex",
        function(value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || re.test(value);
        },
        "لطفا مقدار ورودی را بررسی کنید."
    );

    //File Size Method
    $.validator.addMethod(
        'filesize',
        function (value, element, param) {
            return this.optional(element) || (element.files[0].size <= param)
        },
        'حجم فایل باید کمتر از {0} باشد'
    );

    //Word Count
    function getWordCount(wordString) {
        var words = wordString.split(" ");
        words = words.filter(function(words) {
            return words.length > 0
        }).length;
        return words;
    }

    //Word Count Method
    $.validator.addMethod(
        "wordCount",
        function(value, element, param) {
            var count = getWordCount(value);
            if(count <= param) {
                return true;
            }
        },
        $.validator.format("A maximum of {0} words is required here.")
    );
};

jQuery(document).ready(function($){
    initValidator('.form-validate');
});